import { hash } from '@ember/helper';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import ContentWithSidebar from 'umg-ember-backend/components/ui/content-with-sidebar';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsTaxonomyComponent extends Component {
  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <ContentWithSidebar>
        <:content>
          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field @property='title' />
            <fieldset.field @property='slug' />
            <fieldset.field @property='description' @type='text-editor' />
            <fieldset.field
              @property='taxa'
              @type='has-many'
              @filters={{hash taxonomy=form.model}}
              as |record|
            >
              {{record.displayHeadline}}
            </fieldset.field>
          </form.fieldset>
        </:content>
        <:sidebar>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
            @variantChannelActions={{hash openNewRecord=false openRecord=false}}
          />
          <form.fieldset @titleKey='variant' @isClosed={{true}} as |fieldset|>
            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}
          </form.fieldset>
          <form.fieldset @titleKey='assignments' as |fieldset|>
            <fieldset.field @property='channel' @type='belongs-to' />
            <fieldset.field
              @filters={{hash assetFolderId='10'}}
              @property='image'
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          </form.fieldset>
          <form.sections.meta />
        </:sidebar>
      </ContentWithSidebar>
    </Form>
  </template>
}
